'use client';

import { V4ErrorShell } from '@/components/marketing/route-states/V4ErrorShell';

export default function BestOfSlugError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <V4ErrorShell pillar="rose" error={error} reset={reset} />;
}
